import Swal, { SweetAlertOptions } from "sweetalert2";
import { ExternalToast, toast, ToastT } from "vue-sonner";

/**
 * Composable function to show toasts using SweetAlert2.
 * @param options Override default options for the Swal instance.
 * @returns A set of functions to show different types of toasts.
 */
export const useToast = function () {
	const success = (text: string, data?: ExternalToast) => {
		return toast.success(text, data);
	};

	const promise = (promise: Promise<any>, loadingText: string, successText: string) => {
		const result = toast.promise(promise, {
			loading: loadingText,
			success: (data: any) => {
				return successText;
			},
			error: (data: any) => data.message ?? "Er is iets fout gegaan.",
		});

		if (result == undefined) {
			return Promise.resolve("") as Promise<any>;
		}

		return result;
	};

	const error = (text: string, data?: ExternalToast) => {
		return toast.error(text, data);
	};

	const warn = (text: string, data?: ExternalToast) => {
		return toast.warning(text, data);
	};

	const info = (text: string, data?: ExternalToast) => {
		return toast.info(text, data);
	};

	const confirm = (text: string, options?: SweetAlertOptions) => {
		return Swal.fire({
			icon: "question",
			title: text,
			position: "center",
			showConfirmButton: true,
			showDenyButton: true,
			focusConfirm: false,
			focusDeny: false,
			focusCancel: false,
			returnFocus: false,
			heightAuto: false,
			timerProgressBar: false,
			toast: false,
			customClass: {
				confirmButton: "bg-primary border border-transparent",
				denyButton: "bg-neutral border border-transparent",
			},
			...options,
		});
	};

	return {
		promise,
		success,
		error,
		info,
		confirm,
		warn,
		warning: warn,
		toast,
	};
};
